import { Button, List, Modal } from "antd";
import { useContext, useEffect, useState } from "react";
import useWsSender from "lib/wsSenderHook";
import { showToast } from "ui/components/common";
import { SignalContext } from "context/SignalContext";
import { aesDecrypt, copyToClipBoard } from "lib/utils";
export default function ({ deviceId, orgId }) {
  const [modalShow, setModalShow] = useState(false);
  const [passwordText, setPasswordText] = useState("");
  const { sendWsRequest } = useWsSender();
  const { sessionId } = useContext(SignalContext);
  const getPassword = async () => {
    try {
      const res: any = await sendWsRequest(
        "device.show_password",
        {
          showPassword: {
            deviceId,
          },
        },
        { orgId },
      );
      const passwordText = aesDecrypt(
        res.showPasswordReply.nvrWebPassword,
        sessionId.substring(0, 32),
      );
      setPasswordText(passwordText);
    } catch (error) {
      showToast(1, error?.message || "Failed to get password");
    }
  };
  useEffect(() => {
    if (!modalShow || !sessionId) return;
    getPassword();
  }, [modalShow, sessionId]);

  return (
    <>
      <Button onClick={() => setModalShow(true)} type="link">
        Admin Password
      </Button>
      <Modal
        title={"Admin Password"}
        open={modalShow}
        okButtonProps={{
          style: { display: "none" },
        }}
        cancelButtonProps={{ className: "primaryButton bordered" }}
        onCancel={() => setModalShow(false)}
      >
        <div>
          <span>The password is:</span>
          <span>
            {passwordText && (
              <>
                <div>{`${passwordText}`}</div>
                <a
                  onClick={() => {
                    copyToClipBoard(passwordText);
                  }}
                  className="text-blue-600 hover:text-blue-500 underline"
                  style={{ cursor: "pointer" }}
                >
                  Click to Copy Password
                </a>
              </>
            )}
          </span>
        </div>
      </Modal>
    </>
  );
}
